var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-simple-table', {
    staticStyle: {
      "background-color": "inherit"
    },
    attrs: {
      "dense": ""
    }
  }, [[_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _c('th', [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.title")))]), _c('th', {
    staticClass: "text-end"
  }, [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.amount")))]), _c('th', {
    staticClass: "text-end"
  }, [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.quantity")))]), _c('th', {
    staticClass: "text-end"
  }, [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.taxRate")))]), _c('th', {
    staticClass: "text-end"
  }, [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.total")))])])]), _c('tbody', [_vm._l(_vm.value.lineItems, function (item, index) {
    return [_c('tr', {
      key: index + 'tr1'
    }, [_c('td', {
      staticStyle: {
        "border-bottom": "none"
      }
    }, [_vm._v(_vm._s(index + 1))]), _c('td', {
      staticStyle: {
        "border-bottom": "none"
      }
    }, [_vm.showLink && item.productId ? _c('a', {
      attrs: {
        "href": _vm.productHref(item)
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")]) : _c('span', [_vm._v(" " + _vm._s(item.title) + " ")])]), _c('td', {
      staticClass: "text-end",
      staticStyle: {
        "border-bottom": "none"
      }
    }, [_vm._v(" " + _vm._s(item.amount) + " ")]), _c('td', {
      staticClass: "text-end",
      staticStyle: {
        "border-bottom": "none"
      }
    }, [_vm._v(" " + _vm._s(item.quantity) + " ")]), _c('td', {
      staticClass: "text-end",
      staticStyle: {
        "width": "95px",
        "border-bottom": "none"
      }
    }, [_vm._v(" " + _vm._s(item.taxRate) + " ")]), _c('td', {
      staticClass: "text-end",
      staticStyle: {
        "width": "120px",
        "border-bottom": "none"
      }
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(item.amount * item.quantity, _vm.value.currency)) + " ")])]), _vm.showDescription ? _c('tr', {
      key: index + 'tr2'
    }, [_c('td', {
      staticStyle: {
        "border-top": "none"
      }
    }), _c('td', {
      staticStyle: {
        "border-top": "none"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v(" " + _vm._s(item.description) + " ")])]) : _vm._e()];
  }), _vm.showTotal ? _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.subTotal")) + " ")]), _c('td', {
    staticClass: "text-end",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.totalNet, _vm.value.currency)) + " ")])])]) : _vm._e(), _vm._l(_vm.showTotal ? _vm.value.taxRates : [], function (taxRate) {
    return _c('tr', {
      key: 'taxRate' + taxRate
    }, [_c('td', {
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }), _c('td', {
      staticStyle: {
        "min-width": "150px"
      },
      attrs: {
        "colspan": "1"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.taxTotal")) + " " + _vm._s(taxRate) + " "), _c('span', [_vm._v("%")])])]), _c('td', {
      staticClass: "text-end",
      attrs: {
        "colspan": "1"
      }
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.calcItemsPerTaxRate(taxRate), _vm.value.currency)) + " ")])]);
  }), _vm.showTotal ? _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.total")) + " ")]), _c('td', {
    staticClass: "text-end",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.totalGross, _vm.value.currency)) + " ")])])]) : _vm._e()], 2)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }